<template>
    <div class="admin-users">
        <v-card v-if="tab===1" class="align-self-stretch">
          <v-card-title class="card_ligth_header">
            <h3>Вебинары</h3>
          </v-card-title>
          <v-card-title class="card_ligth_header" style="min-height: 5vh">
            <v-row>
              <v-col cols="12">
                <v-text-field
                    v-model="webinarSearchBody"
                    label="Найти"
                    variant="outlined"
                    clearable
                    hint="Введите ключевое слово для поиска"
                    rounded
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-row>
                  <div class="ml-4">
                    <AppButton
                      class="n-admin-cource__add"
                      @click="webinarDialog = true">
                      <span>Добавить</span>
                    </AppButton>
                  </div>
                  <div class="ml-4">
                    <AppButton
                      class="n-admin-cource__add"
                      @click="tab=2">
                      <span>Серверы</span>
                    </AppButton>
                  </div>
                </v-row> 
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text class="mt-8 pa-0 ">
            <Vue3EasyDataTable
                class="mb-16 pb-16"
                :headers="webinarHeaders"
                :items="webinars"
                :search-value="webinarSearchBody"
                alternating
                show-index
                :rows-per-page-message="'Записей на страницу'"
                :rows-per-page = "10"
                :rows-items="[10,20,50]"
                :rows-of-page-separator-message	="'из'"
                buttons-pagination
                :empty-message="'Данные не добавлены'"
            >

            <template #item-usr="{ webinarModerators, webinarParticipants, webinarParticipantGroups  }">
                <p v-if="!!webinarModerators && webinarModerators.length">Модераторы:</p>
                <v-chip-group column>
                  <v-chip
                      size="small"
                      v-for="m in webinarModerators"
                      :key="m"
                  >{{ m.firstname }} {{ m.lastname }}</v-chip
                  >
                </v-chip-group>

                <p v-if="!!webinarParticipants && webinarParticipants.length">Участники:</p>
                <v-chip-group column>
                  <v-chip
                      size="small"
                      v-for="p in webinarParticipants"
                      :key="p"
                  >{{ p.firstname }} {{ p.lastname }}</v-chip
                  >
                </v-chip-group>

                <p v-if="!!webinarParticipantGroups && webinarParticipantGroups.length">Группы:</p>
                <v-chip-group column>
                  <v-chip
                      size="small"
                      v-for="pg in webinarParticipantGroups"
                      :key="pg"
                  >{{ pg.firstname }} {{ pg.lastname }}</v-chip
                  >
                </v-chip-group>
               
              </template>
  
             
              <template #item-status="{ webinarBeginDateTime, webinarServer, webinarStatus, acceptFreeJoin  }">
                <p v-if="!!webinarBeginDateTime">Дата: <strong>{{ webinarBeginDateTime.replace('T', ' ')}}</strong> </p>
                <p v-if="!!webinarServer">Сервер: 
                  <strong size="small"> {{webinarServer.serverName}}</strong>
                </p>
                <p v-if="!!webinarStatus">Статус:  
                  <strong v-if="webinarStatus === 0">Запланирован</strong>
                  <strong v-if="webinarStatus === 1">Запущен</strong>
                  <strong v-if="webinarStatus === 2">Завершен</strong>
                </p>
                <p v-if="!!acceptFreeJoin">Вход: <strong>любым зарег. пользователям</strong></p>
                <p v-else>Вход: <strong>Выбранные участники</strong></p>
              </template>
  
              <template #item-actions="item">
                <AppButton
                    class="admin-lib__table_button d-flex flex__ai-c"
                    v-if="item.webinarStatus === 0"
                    @click="editWebinar(item)">
                  <span>Изменить</span>
                </AppButton>
                <AppButton
                    class="admin-lib__table_button d-flex flex__ai-c"
                    v-if="item.webinarStatus < 2"
                    @click="beginWebinar(item)">
                  <span>Запустить</span>
                </AppButton>
                <AppButton
                    class="admin-lib__table_button d-flex flex__ai-c"
                    v-if=" item.recordStatus === 1 &&
                            item.webinarRecordUrl !== null"
                    @click="playWebinar(item)">
                  <span>Смотреть</span>
                </AppButton>
                <AppButton
                    class="admin-lib__table_button d-flex flex__ai-c"
                    @click="deleteWebinar(item)">
                  <span>Удалить</span>
                </AppButton>
              </template>
            </Vue3EasyDataTable>
          </v-card-text>
        </v-card>

        <v-card v-if="tab===2" class="align-self-stretch">
          <v-card-title class="card_ligth_header">
            <h3 class="ma-2">Вебинарные серверы</h3>
          </v-card-title>
          <v-card-title class="card_ligth_header" style="min-height: 5vh">
            <v-row>
              <v-col cols="12">
                <v-text-field
                    v-model="serverSearchBody"
                    label="Найти"
                    variant="outlined"
                    clearable
                    hint="Введите ключевое слово для поиска"
                    rounded
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-row>
                  <div class="ml-4">
                    <AppBackButton
                      class="n-admin-cource__back"
                      @click="tab=1">
                      <span>К вебинарам</span>
                    </AppBackButton>
                  </div>
                  <div class="ml-4">
                    <AppButton
                      class="n-admin-cource__add"
                      @click="serverDialog = true">
                      <span>Добавить</span>
                    </AppButton>
                  </div>
                </v-row> 
              </v-col>
             
            </v-row>
          </v-card-title>
          <v-card-text class="ma-0 pa-0">
            <Vue3EasyDataTable
                class="mb-16 pb-16"
                :headers="webinarServerHeaders"
                :items="webinarServers"
                :search-value="serverSearchBody"
                alternating
                show-index
                :rows-per-page-message="'Записей на страницу'"
                :rows-per-page = "10"
                :rows-items="[10,20,50]"
                :rows-of-page-separator-message	="'из'"
                buttons-pagination
                :empty-message="'Данные не добавлены'"
            >
              <template #item-active="{ active }">
                <v-chip size="small" v-if="!!active">Активен</v-chip>
                <v-chip size="small" v-if="!active">Не активен</v-chip>
              </template>
  
              <template #item-actions="item">
                <AppButton
                    class="admin-lib__table_button d-flex flex__ai-c"
                    @click="editServer(item)">
                  <span>Изменить</span>
                </AppButton>
                <AppButton
                    class="admin-lib__table_button d-flex flex__ai-c"
                    @click="deleteServer(item)">
                  <span>Удалить</span>
                </AppButton>
              </template>
            </Vue3EasyDataTable>
          </v-card-text>
        </v-card>
    </div>
    <div>
  
    <v-dialog v-model="webinarDialog" scrollable persistent>
      <v-card>
        <v-card-title class="card_ligth_header">
          <h5>Планирование Вебинара</h5>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="webinarForm">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                      label="Название *"
                      v-model="webinarName"
                      :rules="webinarNameRules"
                      hint="Укажите название сервера"
                      :counter="60"
                      variant="outlined"
                      required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                      label="Аннотация *"
                      v-model="webinarDescription"
                      :rules="webinarDescriptionRules"
                      :counter="1000"
                      variant="outlined"
                      hint="Укажите описание сервера"
                  ></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                      label="Адрес перенаправления при завершении вебинара *"
                      v-model="logoutUrl"
                      :rules="logoutUrlRules"
                      :counter="60"
                      variant="outlined"
                      hint="Укажите адрес"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                      v-model="webinarServer"
                      :items="webinarServers"
                      :rules="webinarServersRules"
                      outlined
                      dense
                      chips
                      small-chips
                      variant="outlined"
                      closable-chips
                      item-title="serverName"
                      item-value="id"
                      label="Сервер"
                  >
                    <template v-slot:chip="{ props, item }">
                      <v-chip
                          v-bind="props"
                          :text="item.raw.serverName"
                      ></v-chip>
                    </template>
                    <template v-slot:item="{ props, item }">
                      <v-list-item
                          v-bind="props"
                          :title="item.raw.serverName"
                          :subtitle="item.raw.serverUrl"
                      ></v-list-item>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                      v-model="webinarModerators"
                      :items="users"
                      :custom-filter="userFilter"
                      outlined
                      dense
                      chips
                      small-chips
                      closable-chips
                      variant="outlined"
                      :rules="webinarModeratorRules"
                      label="Модераторы"
                      multiple
                  >
                    <template v-slot:chip="{ props, item }">
                      <v-chip
                          v-bind="props"
                          :text="item.raw.firstname + ' ' + item.raw.lastname"
                      ></v-chip>
                    </template>
                    <template v-slot:item="{ props, item }">
                      <v-list-item
                          v-bind="props"
                          :title="item.raw.firstname + ' ' + item.raw.lastname"
                          :subtitle="item.raw.username"
                      ></v-list-item>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                      v-model="webinarParticipants"
                      :items="users"
                      :custom-filter="userFilter"
                      outlined
                      dense
                      chips
                      small-chips
                      closable-chips
                      label="Участники"
                      multiple
                  >
                    <template v-slot:chip="{ props, item }">
                      <v-chip
                          v-bind="props"
                          :text="item.raw.firstname + ' ' + item.raw.lastname"
                      ></v-chip>
                    </template>
                    <template v-slot:item="{ props, item }">
                      <v-list-item
                          v-bind="props"
                          :title="item.raw.firstname + ' ' + item.raw.lastname"
                          :subtitle="item.raw.username"
                      ></v-list-item>
                    </template>
                  </v-autocomplete>
                </v-col>
  
                <v-col cols="12">
                  <v-autocomplete
                      v-model="webinarParticipantGroups"
                      :items="userGroups"
                      :custom-filter="userGroupFilter"
                      outlined
                      dense
                      chips
                      small-chips
                      closable-chips
                      label="Группы Участников"
                      multiple
                  >
                    <template v-slot:chip="{ props, item }">
                      <v-chip
                          v-bind="props"
                          :text="item.raw.personGroupName"
                      ></v-chip>
                    </template>
                    <template v-slot:item="{ props, item }">
                      <v-list-item
                          v-bind="props"
                          :title="item.raw.personGroupName"
                          :subtitle="item.raw.personGroupDescription"
                      ></v-list-item>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-label>Дата проведения*</v-label>
                  <datePicker
                      v-model="webinarBeginDateTime"
                      autoApply
                      textInput
                      locale="ru"
                  />
                  <v-alert
                      v-if="webinarDateAlert === true"
                      border="top"
                      color="red lighten-2"
                      dark
                  >
                    Укажите дату проведения вебинара!
                  </v-alert>
                </v-col>
                <v-col cols="12">
                  <v-switch
                      v-model="acceptFreeJoin"
                      hide-details
                      inset
                      label="Вход любым зарег. пользователям"
                  ></v-switch>
                  <v-chip class="ma-2" v-if="acceptFreeJoin"> Да</v-chip>
                  <v-chip v-else class="ma-2"> Нет</v-chip>
                </v-col>

                <v-col cols="12">
                  <v-switch
                      v-model="recordAutostart"
                      hide-details
                      inset
                      :label="
                        this.recordAutostart
                          ? `Автозапуск записи`
                          : `Ручной запуск записи`
                      "
                  ></v-switch>
                  <v-chip class="ma-2" v-if="recordAutostart"> Да</v-chip>
                  <v-chip v-else class="ma-2"> Нет</v-chip>
                </v-col>
              </v-row>
            </v-container>
            <small>*обязательно для заполнения</small>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="card_ligth_actions">
          <v-spacer></v-spacer>
          <AppButton
              class="admin-lib__opener d-flex flex__ai-c"
              @click="closeWebinarForm">
            <span>Отмена</span>
          </AppButton>
          <AppButton
              class="admin-lib__opener d-flex flex__ai-c"
              @click="saveWebinar">
            <span>Сохранить</span>
          </AppButton>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="webinarRedirectDialog" hide-overlay persistent>
      <v-card color="primary">
        <v-card-text>
          Открываем вебинарную комнату в новой вкладке
          <v-progress-linear indeterminate class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="alertDialog">
      <v-card>
        <v-card-text>
          {{ alertDialogMessage }}
        </v-card-text>
        <v-card-actions class="card_ligth_actions">
          <v-btn color="primary" block @click="alertDialog = false"
          >Закрыть</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showRecord" persistent class="large-dialog"  fullscreen>
      <v-card >
        <v-card-text class="iframe-container">
          <iframe :src="this.recordUrl" allowfullscreen></iframe>
        </v-card-text>
        <v-card-actions class="card_ligth_actions">
          <v-btn color="primary" block @click="showRecord = false"
          >Закрыть</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="serverDialog" scrollable>
      <v-card>
        <v-card-title class="card_ligth_header">
          <h5>Вебинарный сервер</h5>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="serverForm">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                      label="Название сервера*"
                      v-model="serverName"
                      :rules="serverNameRules"
                      variant="outlined"
                      hint="Укажите название сервера"
                      :counter="30"
                      required
                  ></v-text-field>
                  <v-alert v-if="nameAlert" type="error"
                  >Сервер с таким именем уже существует!</v-alert
                  >
                </v-col>
                <v-col cols="12">
                  <v-textarea
                      label="Аннотация*"
                      v-model="serverDescription"
                      :rules="serverDescriptionRules"
                      variant="outlined"
                      :counter="25"
                      hint="Укажите описание сервера"
                  ></v-textarea>
                </v-col>
  
                <v-col cols="12">
                  <v-text-field
                      label="URL сервера*"
                      v-model="serverUrl"
                      :rules="serverUrlRules"
                      hint="Укажите URL сервера"
                      variant="outlined"
                      :counter="150"
                      required
                  ></v-text-field>
                </v-col>
  
                <v-col cols="12">
                  <v-text-field
                      label="API KEY*"
                      v-model="serverApiKey"
                      :rules="serverApiKeyRules"
                      variant="outlined"
                      hint="Укажите ключ API сервера"
                      :counter="150"
                      required
                  ></v-text-field>
                </v-col>
  
                <v-col cols="12">
                  <v-switch
                      v-model="active"
                      hide-details
                      inset
                      :label="
                        this.active ? `Сервер активен` : `Сервер не активен`
                      "
                  ></v-switch>
                </v-col>
              </v-row>
            </v-container>
            <small>*обязательно для заполнения</small>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="card_ligth_actions">
          <v-spacer></v-spacer>
          <AppButton
              class="admin-lib__opener d-flex flex__ai-c"
              @click="closeServerForm">
            <span>Отмена</span>
          </AppButton>
          <AppButton
              class="admin-lib__opener d-flex flex__ai-c"
              @click="saveServer">
            <span>Сохранить</span>
          </AppButton>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showLoader" persistent >
      <loader-ring></loader-ring>
    </v-dialog>
    </div>
  </template>
  
  <script>
  import { customAxios} from "@/service/customAxios";
  import {customStorage} from "@/service/customStorage";
  import Vue3EasyDataTable from 'vue3-easy-data-table';
  import 'vue3-easy-data-table/dist/style.css';
  import AppButton from "@/elements/AppButton.vue";
  import LoaderRing from "@/elements/LoaderRing.vue";
  import AppBackButton from "@/elements/AppBackButton.vue";
  
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  
  function getIndex(list,id) {
    for (var i =0; i< list.length; i++) {
      if (list[i].id === id) {
        return i;
      }
    }
    return -1;
  }
  
  export default {
    name: 'AdminCoursePage',
  
    props: [],
    components:{
      LoaderRing,
      AppButton,
      Vue3EasyDataTable,
      AppBackButton
    },
  
    data: () => ({
      webinarParticipants:[],
      webinarParticipantGroups:[],
      showRecord:false,
      recordUrl:'',
      alertDialog:false,
      alertDialogMessage:'',
      webinarRedirectDialog:false,
      webinarName:'',
      webinarDescription:"",
      logoutUrl:'',
      webinarServer:undefined,
      webinarModerators:[],
      webinarBeginDateTime:'',
      webinarDateAlert:false,
      recordAutostart:false,
      acceptFreeJoin: false,
  
      tab:1,
      webinars:[],
      webinarServers:[],
      users:[],
      userGroups:[],
      serverNameRules: [
        (v) => !!v || "Поле обязательно для заполнения!",
        (v) =>
            (v && v.length <= 50) || "Значение до должно превышать 50 символов!",
      ],
      webinarModeratorRules: [
        (v) => !!(v && v.length) || "Поле обязательно для заполнения!",
      ],
      serverDescriptionRules: [
        (v) => !!v || "Поле обязательно для заполнения!",
        (v) =>
            (v && v.length <= 50) || "Значение до должно превышать 50 символов!",
      ],
      webinarServersRules: [
        (v) => (!!v && true) || "Поле обязательно для заполнения!",
      ],
  
  
      serverApiKey:'',
      myWebinarsSearchBody: "",
      webinarServerHeaders: [
        { text: "Название сервера", value: "serverName" },
        { text: "URL сервера", value: "serverUrl" },
        { text: "Статус", value: "active" },
        { text: "Действие", value: "actions" },
      ],

      webinarHeaders: [
        { text: "Название", value: "webinarName", width: 200 },
        { text: "Описание", value: "webinarDescription", width: 200 },
        { text: "Статус", value: "status", width: 250 },
        { text: "Участники", value: "usr", width: 250 },
        { text: "Действие", value: "actions", width: 150},
      ],
      webinarNameRules: [
        (v) => !!v || "Поле обязательно для заполнения!",
        (v) =>
            (v && v.length <= 60) || "Значение не должно превышать 60 символов!",
      ],
      webinarDescriptionRules: [
        (v) => !!v || "Поле обязательно для заполнения!",
        (v) =>
            (v && v.length <= 1000) || "Значение не должно превышать 1000 символов!",
      ],
      serverUrlRules: [
        (v) => !!v || "Поле обязательно для заполнения!",
        (v) =>
            (v && v.length <= 150) || "Значение не должно превышать 150 символов!",
      ],
      serverApiKeyRules: [
        (v) => !!v || "Поле обязательно для заполнения!",
        (v) =>
            (v && v.length <= 150) || "Значение не должно превышать 150 символов!",
      ],
      logoutUrlRules: [
        (v) => !!v || "Поле обязательно для заполнения!",
        (v) =>
            (v && v.length <= 60) || "Значение не должно превышать 60 символов!",
      ],
      webinarSearchBody:'',
      webinarDialog:false,
  
      serverSearchBody:'',
      serverDialog:false,
  
      serverName:'',
      serverDescription:'',
      serverUrl:'',
  
      id:'',
      title:'',
      active:false,
      isPublic:false,
      coach:null,
      coachId: null,
      description:'',
      img:  null,
  
      showLoader: false,
      descriptionRules: [
        v => !!v || 'Поле обязательно для заполнения!',
        v => (v && v.length <= 250) || 'Значение до должно превышать 50 символов!',
      ],
      methodRules: [
        v => !!v || 'Поле обязательно для заполнения!',
      ],
      publishedRules: [
        v => !!v || 'Поле обязательно для заполнения!',
      ],
      titleRules: [
        v => (v && v.length <= 100) || 'Значение до должно превышать 50 символов!',
      ],
      coachRules: [
        v => (!!v && true)  || 'Поле обязательно для заполнения!'
      ],
      webinarRules: [
        v => (v!==undefined)  || 'Поле обязательно для заполнения!'
      ],
      videoFileRules: [
        v => (v!==undefined)  || 'Поле обязательно для заполнения!'
      ],
      nameAlert:false,
      eventDateTimeAlert:false,
  
      courseEvents:[],
      selectedCourse:{},
      courseEventSearchBody:'',
      courseEventDialog:false,
      eventName:'',
      eventDescription:'',
      eventNameRules: [
        v => !!v || 'Поле обязательно для заполнения!',
        v => (v && v.length <= 1500) || 'Значение до должно превышать 1500 символов!',
      ],
      eventDescriptionRules: [
        v => !!v || 'Поле обязательно для заполнения!',
        v => (v && v.length <= 150000) || 'Значение до должно превышать 150000 символов!',
      ],
      eventTypeId: { name: "Вебинар", value: "1" },
      videoFileId:'',
      webinarId:'',
      eventTypes: [
        { name: "Вебинар", id: 1 },
        { name: "Видео из библиотеки", id: 2},
  
      ],
      eventDateTime:'',
      videos:[],
      videoFile:undefined,
      webinar:undefined,
  
  
  
  
  
  
  
    }),
    methods: {
  
      editWebinar(item) {
        this.id = item.id;
        this.acceptFreeJoin = item.acceptFreeJoin;
        this.webinarServerId = item.webinarServer.id;
        this.webinarServer = item.webinarServer;
        this.webinarName = item.webinarName;
        this.webinarDescription = item.webinarDescription;
        this.recordAutostart = item.recordAutostart;
        this.webinarBeginDateTime = item.webinarBeginDateTime;
        this.webinarModerators = item.webinarModerators;
        this.webinarParticipantGroups = item.webinarParticipantGroups;
        this.webinarParticipants = item.webinarParticipants;
        this.logoutUrl = item.logoutUrl;
        this.webinarDialog = true;
      },
      deleteWebinar(item) {
        customAxios.delete("webinar/" + item.id)
            .then((response) => {
              if (response.status === 202) {
                this.webinars.splice(getIndex(this.webinars, item.id), 1);
              } else {
                console.log(response);
              }
            })
            .catch((error) => {
              console.log(error)
            });
      },
      closeServerForm() {
        this.id = "";
        this.acceptFreeJoin = false;
        this.serverName = "";
        this.serverDescription = "";
        this.serverUrl = "";
        this.serverApiKey = "";
        this.logoutUrl = "https://school.eurekacenter.ru";
        this.active = false;
        this.serverDialog = false;
      },
      saveWebinar() {

        if (this.webinarBeginDateTime === null) {
          this.webinarDateAlert = true;
        } else {
          this.webinarDateAlert = false;
  
          this.$refs.webinarForm.validate().then((result) => {
            if (result.valid && this.webinarDateAlert === false) {
  
              if (this.webinarServer instanceof Object)
                this.webinarServer = this.webinarServer.id;
  
              let webinar = {
                webinarServerId: this.webinarServer,
                acceptFreeJoin: this.acceptFreeJoin,
                webinarName: capitalizeFirstLetter(this.webinarName),
                webinarDescription: capitalizeFirstLetter(this.webinarDescription),
                recordAutostart: this.recordAutostart,
                webinarBeginDateTime: this.webinarBeginDateTime,
                webinarModerators: this.webinarModerators.map((v) => ({id: v.id})),
                webinarParticipants: this.webinarParticipants.map((v) => ({id: v.id})),
                webinarParticipantGroups: this.webinarParticipantGroups.map((v) => ({id: v.id})),
                logoutUrl: this.logoutUrl,
              };
              console.log("webinar: " + webinar)
  
              if (this.id) {
                console.log("Редактируем webinar с Id : " + this.id);
                customAxios.put("webinar/" + this.id, webinar)
                    .then((response) => {
                      if (response.status === 202) {
                        let index = getIndex(this.webinars, response.data.id);
                        this.webinars.splice(index, 1, response.data);
                        this.closeWebinarForm();
                      } else {
                        console.log(response);
                      }
                    })
                    .catch((error) => {
                     console.log(error)
                    });
              } else {
                console.log("создаем новый вебинар");
                customAxios.post("webinar", webinar)
                    .then((response) => {
                      if (response.status === 201) {
                        this.webinars.push(response.data);
                        this.closeWebinarForm();
                      } else {
                        console.log(response);
                      }
                    })
                    .catch((error) => {
                     console.log(error)
                    });
              }
            }
          });
        }
      },
      userFilter(item, queryText) {
        console.log("filter item: " + item);
        const textFirstname = item.firstname.toLowerCase();
        const textLastname = item.lastname.toLowerCase();
        const textSecname = item.secname.toLowerCase();
        const searchText = queryText.toLowerCase();
  
        return (
            textFirstname.indexOf(searchText) > -1 ||
            textLastname.indexOf(searchText) > -1 ||
            textSecname.indexOf(searchText) > -1
        );
      },
      userGroupFilter(item, queryText) {
        console.log("filter item: " + item);
        const textPersonGroupName = item.personGroupName.toLowerCase();
        const textPersonGroupDescription =
            item.personGroupDescription.toLowerCase();
  
        const searchText = queryText.toLowerCase();
  
        return (
            textPersonGroupName.indexOf(searchText) > -1 ||
            textPersonGroupDescription.indexOf(searchText) > -1
        );
      },
      playWebinar(item) {
        console.log("play item: " + item.webinarRecordUrl);
        this.showRecord = true;
        this.recordUrl = item.webinarRecordUrl;
      },
      beginWebinar(item) {
  
        console.log("Item ID: " + item.id);
        customAxios.get("webinar/begin/" + item.id)
            .then((response) => {
              if (response.status === 200) {
                console.log("Seminar Join URL :" + response.data.url);
                if (response.data.url !== null) {
                  this.webinarRedirectDialog = true;
                  delay(3000).then(() => {
                    window.open(response.data.url, "_blank");
                    this.webinarRedirectDialog = false;
                  });
                } else {
                  this.alertDialogMessage = response.data.statusComment;
                  this.alertDialog = true;
                }
              } else {
                console.log(response);
              }
            })
            .catch((error) => {
             console.log(error)
            });
      },
      closeWebinarForm() {
        this.id = "";
        this.webinarName = "";
        this.webinarDescription = "";
        this.webinarServer = null;
        this.webinarModerators = null;
        this.webinarParticipants = null;
        this.webinarParticipantGroups = null;
        this.webinarBeginDateTime = null;
        this.logoutUrl = "https://eurekacenter.ru";
        this.recordAutostart = false;
        this.webinarDialog = false;
      },
  
      saveServer() {
        this.$refs.serverForm.validate().then((result) => {
          if (result.valid) {
            let server = {
              serverName: capitalizeFirstLetter(this.serverName),
              serverDescription: capitalizeFirstLetter(this.serverDescription),
              serverUrl: this.serverUrl,
              serverApiKey: this.serverApiKey,
              active: this.active,
            };
            if (this.id) {
              console.log("Редактируем сервер с Id : " + this.id);
              customAxios.put("webinar/server/" + this.id, server)
                  .then((response) => {
                    if (response.status === 202) {
                      let index = getIndex(this.webinarServers, response.data.id);
                      this.webinarServers.splice(index, 1, response.data);
                      this.closeServerForm();
                    } else {
                      alert("что то пошло не так");
                      console.log(response);
                    }
                  })
                  .catch((error) => {
                    console.log(error)
                  });
            } else {
              console.log("создаем новый сервер");
              customAxios.post("webinar/server", server)
                  .then((response) => {
                    if (response.status === 201) {
                      this.webinarServers.push(response.data);
                      this.closeServerForm();
                    } else {
                      console.log(response);
                    }
                  })
                  .catch((error) => {
                   console.log(error)
                  });
            }
  
  
  
          }
        });
      },
      editServer(event) {
        this.id = event.id;
        this.serverName = event.serverName;
        this.serverDescription = event.serverDescription;
        this.serverUrl = event.serverUrl;
        this.serverApiKey = event.serverApiKey;
        this.active = event.active;
        this.serverDialog = true;
      },
      deleteServer(item) {
  
        customAxios.delete("webinar/server/" + item.id)
            .then((response) => {
              if (response.status === 202) {
                this.webinarServers.splice(getIndex(this.webinarServers, item.id), 1);
              } else {
                console.log(response);
              }
            })
            .catch((error) => {
             console.log(error)
            });
      },
    },
    computed: {
  
      usersList(){
        let newUsers = this.users
        return newUsers
      },
      jwtHeaders(){
        let jwtTokenConfig = {
          method: 'POST',
          headers: {
            Authorization: "Bearer " + customStorage.get("user-token"),
          },
          responseType: 'blob'
        }
        return jwtTokenConfig
      },
  
    },
    created: function () {
      this.showLoader=true
      function getWebinars() {
        return customAxios.get('webinar')
  
      }
      function getWebinarServers() {
        return customAxios.get('webinar/server')
      }
  
      function getUsers() {
        return customAxios.get('person/for_webinar')
      }
  
      function getUserGroups() {
        return customAxios.get('person_group/for_webinar')
      }
  
      Promise.all([
        getWebinars(),
        getWebinarServers(),
        getUsers(),
        getUserGroups(),
      ])
          .then(results => {
            if(results[0].status===200){
              this.webinars = results[0].data;
            }
            if(results[1].status===200){
  
              this.webinarServers = results[1].data;
              console.log(this.webinarServers)
            }
            if(results[2].status===200){
              this.users = results[2].data;
            }
            if(results[3].status===200){
              this.userGroups = results[3].data;
            }
          
            this.showLoader=false
          }).catch(error=> {
        this.showLoader=false
        alert("Ошибка: "+error+" загрузки данных, обратитесь к администратору системы!")
  
      });
    }
  }
  function delay(ms) {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }
  </script>
  
  <style lang="scss">
  
  
  
  .customize-table {
    --easy-table-border: 1px solid #2a77bb;
    --easy-table-row-border: 1px solid #2a77bb;
  
    --easy-table-header-font-size: 14px;
    --easy-table-header-height: 50px;
    --easy-table-header-font-color: #E7EBF3;
    --easy-table-header-background-color: #1E88E5;
  
    --easy-table-header-item-padding: 10px 15px;
  
    --easy-table-body-even-row-font-color: #E7EBF3;
    --easy-table-body-even-row-background-color: rgba(28, 132, 224, 0.26);
  
    --easy-table-body-row-font-color: #E7EBF3;
    --easy-table-body-row-background-color: rgba(30, 136, 229, 0.49);
    --easy-table-body-row-height: 50px;
    --easy-table-body-row-font-size: 14px;
  
    --easy-table-body-row-hover-font-color: #1E88E5;
    --easy-table-body-row-hover-background-color: #eee;
  
    --easy-table-body-item-padding: 10px 15px;
  
    --easy-table-footer-background-color: #1E88E5;
    --easy-table-footer-font-color: #c0c7d2;
    --easy-table-footer-font-size: 14px;
    --easy-table-footer-padding: 0px 10px;
    --easy-table-footer-height: 50px;
  
    --easy-table-rows-per-page-selector-width: 70px;
    --easy-table-rows-per-page-selector-option-padding: 10px;
    --easy-table-rows-per-page-selector-z-index: 1;
  
  
    --easy-table-scrollbar-track-color: #2d3a4f;
    --easy-table-scrollbar-color: #2d3a4f;
    --easy-table-scrollbar-thumb-color: #4c5d7a;;
    --easy-table-scrollbar-corner-color: #2d3a4f;
  
    --easy-table-loading-mask-background-color: #2d3a4f;
  }
  
  
  .large-dialog.v-dialog .v-overlay__content {
    max-width: none;
    width: 100%;
  }
  
  .v-dialog--scrollable .v-overlay__content {
    justify-content: center;
  }
  
  .admin-users {
    @include page;
  
    &__item + .admin-clients__item {
      margin-top: 16px;
    }
  
    &__info {
      font-size: 18px;
      line-height: 30px;
  
      span {
        color: $accent-1;
      }
  
      svg {
        margin-right: 8px;
        stroke: $accent-1;
      }
    }
  
    &__name {
      display: flex;
      justify-content: space-between;
    }
  }
  </style>
  